<template>
  <div class="col-12 col-lg-12 u-marg-t-ml u-marg-t-sm--sm">
    <p class="t-h2--md u-marg-b-xxs ordered-props"><span class="n-label n-label--black">1</span> <span>{{ $t('Choose a color') }}{{ setSpace() }}:</span> <span class="u-grey-text">{{ currentColorLabel }}</span></p>
    <div class="u-pad-t-xxs u-pad-b-xxs">
      <div
        v-for="(item, index) in colorsChoices"
        :key="item.value"
        :class="['gtm-section-product-color c-color-swatch c-color-swatch--big c-color-swatch--has-hover', index > 0 ? 'u-marg-l-xxs' : '', item.selected ? 'is-active' : '']"
        @click="onSelected(index, item)"
        :data-label="item.label"
        :style="`background-color: ${item.swatch}`"></div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import Helpers from '~plugins/Helpers'
import { UpdatedAvailablePlans, AddSpaceFr } from './Mixins/CustomOptionsMixins'

import isEmpty from 'lodash.isempty'

export default {
  props: {
    colors: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      colorsChoices: [],
      currentColorLabel: '',
      product: {}
    }
  },
  beforeMount () {

    let colorIndex = 0;
    this.product = {...this.currentProduct}

    for (let dataProductIndex in this.productInformations.skus){
      if(this.productInformations.skus[dataProductIndex].sku == this.product.sku){
        colorIndex = this.productInformations.skus[dataProductIndex].colorIndex;
      }
    }

    this.colorsChoices = this.colors.map((item, index) => ({...item, selected: index === colorIndex}))

    if (Helpers.getParamValue('color') && Helpers.getParamValue('color') !== '' && Helpers.isHexValid(Helpers.getParamValue('color'))) {

      const urlSwatch = Helpers.getParamValue('color')

      let currentColor = {...this.colorsChoices.find(color => color.swatch === `#${urlSwatch}`)}
      colorIndex = this.colorsChoices.findIndex(color => color.swatch === `#${urlSwatch}`)

      // If the value from the url don't match we default to the first choice
      if (colorIndex === -1) colorIndex = 0
      if (isEmpty(currentColor)) currentColor = {...this.colorsChoices[colorIndex]}

       // Update the selected color with the color from the URL
      this.colorsChoices = this.colors.map((item, index) => ({...item, selected: index === colorIndex}))

      this.generateProductColor(currentColor, colorIndex)

    } else {

      this.generateProductColor({...this.colorsChoices[colorIndex]}, colorIndex)
    }

    this.setCurrentProduct({currentProduct: this.product})
  },
  mounted () {
    // Because we can't control the load of the native magento form
    // we check every 500ms if the form exists
    const timer = setInterval(() => {
      const color = document.querySelector(`#option-label-color-${this.productInformations.super_attributes.color.id}-item-${this.currentProduct.color.id}`)
      const selected_active_color = document.querySelector("gtm-section-product-color c-color-swatch c-color-swatch--big c-color-swatch--has-hover, .is-active")

      if (color) {
        this.product = this.currentProduct
        color.click()
        selected_active_color.click()
        clearInterval(timer)
        // enable the add to cart button
        this.product.formReady = true
        this.setCurrentProduct({currentProduct: this.product})
      }
    }, 500)
  },
  computed: {
    ...mapGetters({
      currentProduct: 'GET_CURRENT_PRODUCT',
      productInformations: 'GET_PRODUCT_INFORMATIONS',
      $t: 'GET_TRAD'
    })
  },
  methods: {
    ...mapActions({
      setCurrentProduct: 'SET_CURRENT_PRODUCT'
    }),
    ...mapMutations({
      updateButtonState: 'UPDATE_ADD_TO_CART_BUTTON_STATE',
    }),
    setSpace(){
      return AddSpaceFr(this.productInformations)
    },
    /**
     * Generate the correct information for the selected color
     * @param {number} colorIndex - index of the current color.
     *
     * @return {
     *   capacities: [],
     *   availability: false || true,
     *   availability_color: '',
     *   products: [],
     *   selected: true,
     *   swatch: ''
     * }
     */
    generateProductColor (currentColor, colorIndex) {
      this.currentColorLabel = this.colors[colorIndex].label

      const currentProductMix = currentColor.products.find(product => product.sku === this.product.sku)

      /**
       * If currentProductMix is undefined it means the product is not in stock so we fallback to the availability = false instead of breaking the app
       */
      this.product.color = {
        ...this.colorsChoices[colorIndex],
        index: colorIndex,
        availability: currentProductMix && currentProductMix.availability ? currentProductMix.availability : false,
        availability_color: currentProductMix && currentProductMix.availability_color ? currentProductMix.availability_color : ''
      }
    },
    onSelected (index, item) {

      // Clone this.currentProduct
      // Update this.product if something has changed in the global state
      this.product = {...this.currentProduct}

      /**
       * Before changing color we RESET the capacity to avoid having this problem :
       * color red = salable, capacity 128gb = salable
       * color blue = salable, capacity 128gb = is not salable but 256gb  = salable
       *
       * If we select red and 128gb, the blue color is not avaible because the blue doesn't have a 128gb avaliable
       */

      const capacityBefore = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.product.capacity.id}`)
      if (capacityBefore && !capacityBefore.disabled && Helpers.isChecked(capacityBefore)) {
        capacityBefore.click()
      }

      for (let i = 0; i < this.colorsChoices.length; i++) {
        this.colorsChoices[i].selected = false
      }

      this.colorsChoices[index].selected = true
      this.currentColorLabel = this.colorsChoices[index].label

      let capacityMapping = this.productInformations.super_attributes.color.options.find(capacity => item.id === capacity.id)

      this.product.capacityMapping = capacityMapping.capacities


      let checkIfCapacityIndexIsSalable = this.product.capacityMapping.findIndex(capacity => capacity[Object.keys(capacity)[0]].is_salable)

      if (checkIfCapacityIndexIsSalable === -1) {
        this.product.capacity = {
          ...this.product.capacityMapping[0][Object.keys(this.product.capacityMapping[0])[0]],
          index: 0
        }
      } else {
        this.product.capacity = {
          ...this.product.capacityMapping[checkIfCapacityIndexIsSalable][Object.keys(this.product.capacityMapping[checkIfCapacityIndexIsSalable])[0]],
          index: checkIfCapacityIndexIsSalable
        }
      }


      // Make sure there is a salable capacity before enabled the add to cart button
      if (this.product.capacityMapping.findIndex(capacity => capacity[Object.keys(capacity)[0]].is_salable) === -1) {
        this.updateButtonState('disabled')
      } else {
        this.updateButtonState('enabled')
      }

      const currentSku = this.colorsChoices[index].products[this.product.capacity.index].sku

      const currentColor = {...this.colorsChoices[index]}

      const currentProductMix = currentColor.products.find(product => product.sku === currentSku)

      this.product.color = {
        ...this.colorsChoices[index],
        index: index,
        availability: currentProductMix.availability,
        availability_color: currentProductMix.availability_color
      }

      this.product.sku = currentSku

      let defaultAvailablePlans = [...this.productInformations.plans[currentSku]]
      let filterAvailablePlans = [...this.productInformations.plans[currentSku]]

      this.product.availablePlans = UpdatedAvailablePlans({
        defaultAvailablePlans,
        filterAvailablePlans,
        planSku: this.product.plan.sku
      })

      this.setCurrentProduct({currentProduct: this.product})

      const selectNewCapacity = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.product.capacity.id}`)
      const isCapacityChecked = Helpers.isChecked(selectNewCapacity)
      const selectNewColor = document.querySelector(`#option-label-color-${this.productInformations.super_attributes.color.id}-item-${this.product.color.id}`)

      if (selectNewColor && !selectNewColor.disabled && !Helpers.isChecked(selectNewColor)) selectNewColor.click()

      if (selectNewCapacity && !selectNewCapacity.disabled && !isCapacityChecked) selectNewCapacity.click()

      // loading is to make sure the click happend only after the user clicked on a capacity
      let loading = true

      // Apply capacity after the updated options are loaded in the dom
      $(document).ajaxComplete((event, request, settings) => {
        if (settings.url.includes('LoadOptions') && loading) {
          const currentCapacity = document.querySelector(`#option-label-device_capacity-${this.productInformations.super_attributes.device_capacity.id}-item-${this.currentProduct.capacity.id}`)

          if (currentCapacity && !currentCapacity.disabled && !Helpers.isChecked(currentCapacity)) {
            currentCapacity.click()
            loading = false
          }
        }
      })
    }
  }
}
</script>
